import { ProjectDialogService } from '../../../core/services/project-dialog.service';
import type { ProyectosInitialSheet } from '../../../core/interfaces/backend/proyectos/proyectos.interface';
import type { DirtyPage } from '../../../core/interfaces/navigation/dirty-page.interface';
import type { SectionCatalogs, Workspace, ProblemTree, ProjectActor } from '../../../core/interfaces/backend/proyectos/project-sections.interface';
import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiAuthService } from '../public/api-auth/api-auth.service';
import { Observable, map } from 'rxjs';
import { CanDeactivateFn } from '@angular/router';
import type { SectionFile } from '../../../core/interfaces/http/section-file.interface';

export const unsavedChangesGuard: CanDeactivateFn<DirtyPage> = page => !page.dirty || inject(ProjectDialogService).confirm('Hay cambios sin guardar. ¿Desea salir y descartarlos?');
@Injectable({ providedIn: 'root' })
export class ProjectSectionsService {
    private readonly http = inject(HttpClient);
    private readonly auth = inject(ApiAuthService);
    readonly url = this.auth.baseUrl + '/pvt/gb/proyectos';
    catalogs(): Observable<SectionCatalogs> { return this.http.get<{
        data: SectionCatalogs;
    }>(this.url + '/workspace/catalogs').pipe(map(r => r.data)); }
    workspace(id: string): Observable<Workspace> { return this.http.get<{
        data: Workspace;
    }>(this.url + '/workspace/' + id).pipe(map(r => r.data)); }
    sheet(body: ProyectosInitialSheet): Observable<{
        id_registro: string;
    }> { return this.http.post<{
        data: {
            id_registro: string;
        };
    }>(this.url + '/initial-sheet', body).pipe(map(r => r.data)); }
    tree(id: string, body: ProblemTree, confirmar_dependencias = false): Observable<ProblemTree> { return this.http.post<{
        data: ProblemTree;
    }>(this.url + '/workspace/' + id + '/problems', { central: body.central, nodes: body.nodes, ...(confirmar_dependencias ? {confirmar_dependencias} : {}) }).pipe(map(r => r.data)); }
    actors(id: string, actors: ProjectActor[], files: SectionFile[] = []): Observable<Workspace> { return this.http.post<{
        data: Workspace;
    }>(this.url + '/workspace/' + id + '/actors', { actors, archivos: files.map(f => ({id_registro:f.id_registro,id_archivo_tipo:f.id_archivo_tipo,nombre:f.nombre,contenido:f.contenido})) }).pipe(map(r => r.data)); }
    downloadActorFile(id: string, fileId: string): Observable<Blob> {
        return this.http.get(this.url + '/workspace/' + id + '/actors/files/' + fileId, {responseType:'blob'});
    }
}
